import { Component, OnInit } from '@angular/core';
///IDIOMAS
import { lang_help } from 'app/idiomas/i18n/ayuda/ayuda.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { fuseAnimations } from '@fuse/animations';
import { WizardService } from 'app/main/wizard-n35/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import * as colabInter from 'app/main/pagina/encuestador-n35/colaboradores35/colaboradores35.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-videos35',
  templateUrl: './videos35.component.html',
  styleUrls: ['./videos35.component.scss'],
  animations : fuseAnimations
})
export class Videos35Component implements OnInit {
  productoCertificar: backInter.prodNorma35;
  password:boolean = false;
  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private wizardService: WizardService,
  ) {
    lang_help.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
   }

  ngOnInit() {
    this.obtieneCertificarActual();
  }
  obtieneCertificarActual(){
    console.log("Obtener actual");
     this.wizardService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
       let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
       var BreakException = {};
       try {
         prodsCertificar.forEach( (producto) => {
           if(producto.completoNorma35 === 1){
             this.productoCertificar = producto;
             console.log(this.productoCertificar);
             throw BreakException;
           }
           });
       } catch (e) {
           if (e !== BreakException) throw e;
       };

     }, error  => {
       console.log("error al recuperar certificar vigente");
     });
   }

   private onPassword(event){
     console.log("Entro dude");
    let Pass:any;
    Pass=event.target.value.trim();
    console.log("Password "+Pass);
    //this.productoCertificar.claveVideo;
    if(Pass == this.productoCertificar.claveVideo){
      this.password=true;

      Swal.fire({
        icon: 'success',
        title: 'Contraseña correcta', // advice 5
        confirmButtonColor: '#e40601'
      });

    }else{
      Swal.fire({
        icon: 'error',
        title: 'Contraseña no valida', // advice 5
        confirmButtonColor: '#e40601'
      });
    }
  }
/*{
      titulo  : "Bienvenida",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/norma-035_Instruccionales/00.-Bienvenida.mp4',
    },
*/
  videoIns1 =[
    {
      titulo  : "Planeación ejecutiva",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/norma-035_Instruccionales/01PlaneacionEjecutiva.mp4' ,
    },{
      titulo  : "Sensibilización",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/norma-035_Instruccionales/02 Sensibilizacion.mp4',
    },{
      titulo  : "Comunicación",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/norma-035_Instruccionales/03Comunicacion.mp4',
    }
  ]

  videoIns2 =[
    {
      titulo  : "Capacitación",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/norma-035_Instruccionales/04.-Capacitacion.mp4' ,
    },{
      titulo  : "Acontecimiento traumático severo",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/norma-035_Instruccionales/05.-Acontecimiento Traumatico Severo.mp4',
    },{
      titulo  : "Factores de riesgo psicosocial",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/norma-035_Instruccionales/06 Factores de Riesgo Psicosocial.mp4',
    }
  ]

  videoIns3 =[
   {
      titulo  : "Resultados",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/norma-035_Instruccionales/07Resultados__.mp4' ,
    },{
      titulo  : "Análisis e interpretación",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/norma-035_Instruccionales/8. Analisis e interpretacion.mp4',
    },{
      titulo  : "Plan de acción",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/norma-035_Instruccionales/09Plan de accion_.mp4',
    },
  ]

  videoIns4 =[
    {
      titulo  : "Mejora continua",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/norma-035_Instruccionales/video10 Mejora continua.mp4' ,
    }

  ]




  video2 =[
    {
      video : [
        {
          titulo  : "Plan de acción",
          descripcion  : "",
          liga: DATOS_API.urlAssets + 'video/norma-035_Instruccionales/09Plan de accion_.mp4',
        },{
          titulo  : "Mejora continua",
          descripcion  : "",
          liga: DATOS_API.urlAssets + 'video/norma-035_Instruccionales/video10 Mejora continua.mp4' ,
        }
      ]
    }
  ]
  videosBetter = [
    
     {
      video : [
        {
          titulo  : "Bienvenida",
          descripcion  : "",
          liga: DATOS_API.urlAssets + 'video/norma-035_Instruccionales/00.-Bienvenida.mp4',
        },{
          titulo  : "Planeación ejecutiva",
          descripcion  : "",
          liga: DATOS_API.urlAssets + 'video/norma-035_Instruccionales/01PlaneacionEjecutiva_.mp4' ,
        },{
          titulo  : "Sensibilización",
          descripcion  : "",
          liga: DATOS_API.urlAssets + 'video/norma-035_Instruccionales/02.-Sensibilizacion.mp4',
        }
      ]
     },
     {
      video : [
        {
          titulo  : "Comunicación",
          descripcion  : "",
          liga: DATOS_API.urlAssets + 'video/norma-035_Instruccionales/03Comunicacion.mov',
        },{
          titulo  : "Capacitación",
          descripcion  : "",
          liga: DATOS_API.urlAssets + 'video/norma-035_Instruccionales/04.-Capacitacion.mp4' ,
        },{
          titulo  : "Acontecimiento traumático severo",
          descripcion  : "",
          liga: DATOS_API.urlAssets + 'video/norma-035_Instruccionales/05.-Acontecimiento Traumatico Severo.mp4',
        }
      ]
     },
     {
      video : [
        {
          titulo  : "Factores de riesgo psicosocial",
          descripcion  : "",
          liga: DATOS_API.urlAssets + 'video/norma-035_Instruccionales/6.-Factores de Riesgo Psicosocial.mp4',
        },{
          titulo  : "Resultados",
          descripcion  : "",
          liga: DATOS_API.urlAssets + 'video/norma-035_Instruccionales/07Resultados__.mp4' ,
        },{
          titulo  : "Análisis e interpretación",
          descripcion  : "",
          liga: DATOS_API.urlAssets + 'video/norma-035_Instruccionales/8. Analisis e interpretacion.mp4',
        }
      ]
     },

  ]
}
